import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Footer.css";

function Footer() {
  const { t, i18n } = useTranslation();
  const isKorean = i18n.resolvedLanguage === "ko" || i18n.language?.startsWith("ko");

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-business-info">
          <p><strong>{isKorean ? "상호명" : "Business Name"}:</strong> 스타트어스 (STARTUS)</p>
          <p><strong>{isKorean ? "대표자" : "Representative"}:</strong> 김민석</p>
          <p><strong>{isKorean ? "사업자등록번호" : "Business Registration No."}:</strong> 530-28-02105</p>
          <p><strong>{isKorean ? "사업장 주소" : "Business Address"}:</strong> 서울특별시 관악구 남부순환로 149길 33</p>
          <p>
            <strong>{isKorean ? "전화번호" : "Phone"}:</strong>{" "}
            <a href="tel:+821089833323">010-8983-3323</a>
          </p>
          <p>
            <strong>{isKorean ? "이메일" : "Email"}:</strong>{" "}
            <a href="mailto:admin@start-us.com">admin@start-us.com</a>
          </p>
        </div>

        <nav className="footer-policy-links" aria-label={isKorean ? "정책" : "Policies"}>
          <Link to="/pricing">{t('footer.pricing')}</Link>
          <Link to="/terms">{t('footer.terms')}</Link>
          <Link to="/privacy">{t('footer.privacy')}</Link>
          <Link to="/refund-policy">{t('footer.refund')}</Link>
        </nav>

        <p className="footer-copyright">{t('footer.copyright')}</p>
      </div>
    </footer>
  );
}

export default Footer;
